<hf-date-picker
  [formControl]="inputControl"
  [propertyName]="propertyName"
  [onlyDate]="!withTime"
  [minDate]="minDate"
  [maxDate]="maxDate"
  class="desktop-date-time"
  [isInvalid]="invalid"
></hf-date-picker>

<div class="flex-space-between-layout native-mobile-date-time">
  <hf-custom-native-mobile-datetime
    [formControl]="inputControl"
    [onlyDate]="!withTime"
    [minDate]="minDate"
    [invalid]="invalid"
    class="native-mobile-date-time"
  >
  </hf-custom-native-mobile-datetime>
</div>
